import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { initAuth } from "./redux/auth.reducer";
import { Provider } from "react-redux";
import ContextLanguage from "./context/Context.Language";
import ContextCart from "./context/Context.Cart";
import { LoadDataFromS3 } from "./redux/load.reducer";
import { LoadBannerFromS3 } from "./redux/banner.reducer";
import { BrowserRouter as Router } from "react-router-dom";
import GoogleTagManager from "./utils/useGoogleTag";

GoogleTagManager.initialize({
  gtmId: "GTM-N7RXMXX",
});

GoogleTagManager.initialize({
  gtmId: "GTM-56BHM9S",
});

store.dispatch(LoadBannerFromS3());
store.dispatch(LoadDataFromS3());
store.dispatch(initAuth());

const root = ReactDOM.createRoot(document.getElementById("root"));

let Element = () => {
  return (
    <Router>
      <Provider store={store}>
        <ContextLanguage>
          <ContextCart>
            <App />
          </ContextCart>
        </ContextLanguage>
      </Provider>
    </Router>
  );
};

// const rootElement = document.getElementById("root");

// if (rootElement.hasChildNodes()) {
// hydrate(<Element />, rootElement);
// } else {
root.render(<Element />);
// }

reportWebVitals();
